import React, { Suspense } from "react";
import { defineMessages, FormattedMessage, injectIntl } from "react-intl";
import { IconCloseRed, IconPerson, IconSearch } from "../../icons/svg/index.js";
import ContactList from "../contact-list.jsx";
import LetterTile from "../letter-tile.jsx";
import { makeImageUrl } from "../../lib/blob-helpers.js";
import { Topic } from "../../tinode/topic.js";
import MessagesUtil from "../../tinode/messagesUtils.js";
import * as MC_CONST from '../../tinode/constants'
import StringUtils from '../../lib/string'
import PhoneUtils from '../../lib/phoneUtils'
import Helpers from "../../lib/helpers.js"
import lodash from 'lodash'
import AccessMode from '../../tinode/access-mode'
import { ADD_ACTIVE_MEMBER_SEARCH } from '../../config'

const messages = defineMessages({
  add_member_success: {
    id: 'add_member_success',
    description: 'Add member success',
    defaultMessage: 'Notify Add member to group success'
  },
  add_member_failed: {
    id: 'add_member_failed',
    description: 'Add member failed',
    defaultMessage: 'Notify Add member to group failed'
  },
  notify_create_group: {
    id: 'notify_create_group',
    description: 'You have created the group {groupName}',
    defaultMessage: 'Notify created group success.'
  },
  notify_creator_invite_member_group: {
    id: 'notify_creator_invite_member_group',
    defaultMessage: '{memberName} joined group',
    description: 'Notify creator add member to group success.'
  },
  sidepanel_search: {
    id: 'sidepanel_search',
    defaultMessage: "Search",
    description: "Search",
  },
  dialog_group_name: {
    id: 'dialog_group_name',
    defaultMessage: "Group name",
    description: "Group name",
  }
})

class CreateGroup extends React.Component {
  constructor(props) {
    super(props);

    this.fullName = React.createRef();

    this.state = {
      fullName: '', // full/formatted name
      private: '',
      description: '',
      imageUrl: null,
      tags: [],
      isChannel: false,
      newAvatar: null,
      newAvatarMime: null,
      disableCreate: true,
      members: [],
      topicSelected: [],
      search: '',
      contacts: this.sortContacts(props.contacts),
    };

    this.getDefaultContacts = this.getDefaultContacts.bind(this);
    this.handleSearchContact = this.handleSearchContact.bind(this);
    this.handleAddPhoneQuery = this.handleAddPhoneQuery.bind(this);
    this.handleOnGroupFullNameChange = this.handleOnGroupFullNameChange.bind(this);
    this.handleDone = this.handleDone.bind(this);
    this.handleSelectedMember = this.handleSelectedMember.bind(this);
    this.handleRemoveSelectedMember = this.handleRemoveSelectedMember.bind(this);
    this.createGroup = this.createGroup.bind(this);
    this.updateListContact = this.updateListContact.bind(this);
    this.handleMemberSelected = this.handleMemberSelected.bind(this);
    this.handleContextMenu = this.handleContextMenu.bind(this);
    this.handleAddMember = this.handleAddMember.bind(this);

  }

  sortContacts(listContacts) {
    listContacts.sort((a, b) => {
      return (b.touched ? b.touched.getTime() : 0) - (a.touched ? a.touched.getTime() : 0)
    })
    return listContacts
  }

  componentDidMount() {
    this.updateListContact()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.view !== this.props.view) {
      this.updateListContact()
    }
  }

  updateListContact() {
    const contacts = this.getDefaultContacts()

    this.setState({ contacts })
  }

  getDefaultContacts() {
    let contacts = this.props.contacts.filter(c => {
      // Chat 1-1
      let res = Topic.isP2PTopicName(c.name)
      // Không phải Official Account
      res = res && !c.isOfficial
      // Không phải người lạ
      res = res && !c?.stranger
      // Không phải là Group
      if (!res) return res
      // Hoặc cuộc trò chuyện có tin nhắn
      res = res || (c.latestMessage && c.latestMessage())
      // Tài khoản active
      if (ADD_ACTIVE_MEMBER_SEARCH) {
        res = res && (c.public && c.public.state && (c.public.state === 1 || c.public.state === 2))
      }
      return res
    })
    switch (this.props.view) {
      case MC_CONST.GROUP_MEMBER_VIEW_TYPE.ADD_MEMBER: {
        // const listMember = this.props.members.map(m => m.user)
        // contacts = contacts.filter(c => listMember.includes(c.name) === false)
        break
      }
      case MC_CONST.GROUP_MEMBER_VIEW_TYPE.VIEW_MEMBER: {
        contacts = this.props.members
        break
      }
      case MC_CONST.GROUP_MEMBER_VIEW_TYPE.CREATE_GROUP: {
        break
      }
      default: {
        break
      }
    }
    return this.sortContacts(contacts)
  }

  handleOnGroupFullNameChange(e) {
    this.setState({ fullName: e.target.value })
  }

  handleSearchContact(e) {
    const search = e.target.value || ''

    const key = StringUtils.removeAccents(search.trim())

    let isHaveTopic = false

    let contacts = this.getDefaultContacts().filter((contact) => {
      const topicId = contact.name
      if (Topic.isP2PTopicName(topicId)) {
        const msisdn = Topic.getThreadId(topicId)
        const formatedMsisdn = PhoneUtils.formatPhoneNumber(msisdn)
        const formatedMsisdnKey = PhoneUtils.formatPhoneNumber(key)
        if (formatedMsisdn === formatedMsisdnKey) {
          isHaveTopic = true
        }
        const name = lodash.has(contact, 'private.comment') ? contact.private.comment : ''
        const cKey = `${msisdn}|${name}`
        return StringUtils.noAccentsMatch(cKey, key)
      }
      return false
    })

    if (!isHaveTopic && PhoneUtils.isValidPhoneNumberByCountry(search)) {
      const phone = PhoneUtils.formatPhoneNumber(search)
      const topicId = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.CHAT, phone);
      if (contacts.filter(c => c.name === topicId).length === 0) {
        this.handleAddPhoneQuery(phone, topicId, contacts)
      }
    }


    this.setState({
      search,
      contacts,
    });

  }

  handleAddPhoneQuery(phone, topicId, contacts) {
    if (contacts.filter(c => c.topic === topicId).length === 0) {
      this.props.tinode.getUserProfile(phone).then((pub) => {
        if (pub) {
          const topic = {
            acs: new AccessMode({
              mode: "",
            }),
            public: pub,
            private: {
              comment: phone
            },
            user: topicId,
          }
          contacts.push(topic)
          this.setState({
            contacts: lodash.sortBy(contacts, 'private.comment'),
          })
        }

      })
    }
  }


  handleDone(e) {
    switch (this.props.view) {
      case MC_CONST.GROUP_MEMBER_VIEW_TYPE.ADD_MEMBER: {
        this.handleAddMember(e)
        break
      }
      case MC_CONST.GROUP_MEMBER_VIEW_TYPE.VIEW_MEMBER: {
        break
      }
      case MC_CONST.GROUP_MEMBER_VIEW_TYPE.CREATE_GROUP: {
        this.createGroup(e)
        break
      }
      default: {
        break
      }
    }
  }

  createGroup(e) {
    e.preventDefault();
    const { formatMessage } = this.props.intl;
    const listMembers = this.state.topicSelected.map(member => Topic.getThreadId(member.topic))
    const name = this.state.fullName || 'Group'
    const id = MessagesUtil.xmppid()
    this.props.tinode.sendRequestCreateGroup(name, listMembers, id).then((resultData) => {
      const { topicId } = resultData
      const body = formatMessage(messages.notify_create_group)
      this.props.onTopicSelected(topicId);
      this.props.onClose();
      this.props.tinode.addMessageNotify(topicId, MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, {
        body,
        timesend: new Date().getTime(),
        id,
      })
    })
  }

  handleAddMember(e) {
    const { formatMessage } = this.props.intl;
    e.preventDefault();
    const listMemberToAdd = this.state.topicSelected.map(m => Topic.getThreadId(m.topic))
    const topicId = this.props.topic
    const id = MessagesUtil.xmppid()
    this.props.tinode.sendRequestAddGroupMember(topicId, listMemberToAdd, id).then((resultData) => {
      switch (resultData.errorCode) {
        case MC_CONST.IQ_RESULT_CODE.SUCCESS: {
          const listMemberAdd = resultData?.invited
          if (listMemberAdd && Array.isArray(listMemberAdd) && listMemberAdd.length > 0) {
            const listMemberSuccess = listMemberAdd.map((info) => {
              if (info?.jid) {
                const invitedPerson = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.CHAT, info.jid)
                const topicPerson = this.props.tinode.getTopicByName(invitedPerson, { isCreateWhenNotExist: true })
                const personName = Topic.getTopicName(topicPerson) || info.jid
                const memInfo = {
                  ...info,
                  memberInfo: personName
                };
                return memInfo;
              }

            })

            const invitePerson = listMemberSuccess.map(item => item.memberInfo).join(", ");
            const body = formatMessage(messages.notify_creator_invite_member_group, { memberName: invitePerson })
            const idNew = MessagesUtil.xmppid();
            this.props.tinode.addMessageNotify(topicId, MC_CONST.NODE_TYPE_MESSAGE.GROUPCHAT, {
              body,
              timesend: new Date().getTime(),
              id: idNew,
            })
          }
          this.props.onClose()
          Helpers.showSuccessToasts(formatMessage(messages.add_member_success))
          break;
        }
        case MC_CONST.IQ_RESULT_CODE.ERROR:
        default: {
          Helpers.showErrorToasts(formatMessage(messages.add_member_failed))
          break;
        }
      }

    })
  }

  handleSelectedMember(topicName) {
    const topicSelected = this.state.topicSelected;
    const { members } = this.props
    if (!(members && members.find(v => v.user === topicName))) {
      if (topicSelected.filter(topic => topic.topic === topicName).length === 0) {
        const lmember = this.props.contacts.filter(topic => topic.topic === topicName)
        if (lmember.length > 0) {
          const member = lmember[0]
          topicSelected.push(member)
          this.setState({
            topicSelected,
            disableCreate: topicSelected.length < 2,
          })
        }
      } else {
        const newTopicSelected = topicSelected.filter(topic => topic.topic !== topicName)
        this.setState({
          topicSelected: newTopicSelected,
          disableCreate: topicSelected.length < 2,
        })
      }
    }
  }

  handleRemoveSelectedMember(topicName) {
    if (this.state.topicSelected.filter(topic => topic.topic === topicName).length > 0) {
      const topicSelected = this.state.topicSelected.filter((topic) => topic.topic !== topicName)
      this.setState({
        topicSelected,
        disableCreate: topicSelected.length < 2,
      })
    }
  }

  handleMemberSelected(topicName) {
    console.log('===============handleMemberSelected', topicName)
  }

  handleContextMenu() {

  }

  renderSearchView() {
    const { formatMessage } = this.props.intl;
    let listMember = [];
    if (this.props.view === MC_CONST.GROUP_MEMBER_VIEW_TYPE.ADD_MEMBER && this.props.members && this.props.members.length > 0) {
      listMember = this.props.members.map(item => {
        return {...item, ...{topic: item.user}};
      });
    }
    const listCheckMakr = [...listMember, ...this.state.topicSelected];
    return (
      <React.Fragment>
        <div className="search-contact">
          <div className="icon"><IconSearch /></div>
          <input type="text"
            placeholder={formatMessage(messages.sidepanel_search)}
            onChange={this.handleSearchContact}
            value={this.state.search} />
        </div>
        {
          this.state.topicSelected.length > 0 &&
          <div className="list-selected">
            {this.state.topicSelected.map((contact, key) => {
              const avatar = makeImageUrl(contact.public ? contact.public.photo : null)
              const name = contact.private && contact.private.comment ? contact.private.comment : contact.public.fn
              return (
                <div className="item" key={key}>
                  <div className="avatar">
                    <LetterTile
                      tinode={this.props.tinode}
                      avatar={avatar ? avatar : true}
                      title={name}
                      topic={contact.topic || contact.user}
                    />
                    <div className="icon-close" onClick={() => this.handleRemoveSelectedMember(contact.topic)}>
                      <IconCloseRed />
                    </div>
                  </div>
                  <div className="name">
                    {name}
                  </div>
                </div>
              )
            })}
          </div>
        }
        <div className="contacts">
          <div className="title">
            <FormattedMessage
              id="dialog_recent_contact"
              defaultMessage="Recent contact" />
          </div>
          <div className="list-contacts">
            <ContactList
              tinode={this.props.tinode}
              contacts={this.state.contacts}
              myUserId={this.props.myUserId}
              emptyListMessage={''}
              showOnline={false}
              showUnread={false}
              showContextMenu={false}
              showCheckmarkContact={true}
              onTopicSelected={this.handleSelectedMember}
              listCheckmakrContacts={listCheckMakr}
              showContactMode={MC_CONST.CONTACT_LIST_SHOW_MODE.PHONE_NUMBER}
              />
          </div>
        </div>
      </React.Fragment>
    )
  }

  renderHeader() {
    switch (this.props.view) {
      case MC_CONST.GROUP_MEMBER_VIEW_TYPE.ADD_MEMBER: {
        return (
          <div className="header">
            {<button className="back" onClick={this.props.onClose}>
              <FormattedMessage id="dialog_button_cancel" defaultMessage={"Cancel"} />
            </button>}
            <div className="title">
              <FormattedMessage id="dialog_title_add_group_member" defaultMessage={"Create group"} />
            </div>
            {<button className="done" onClick={this.handleDone} disabled={!(this.state.topicSelected.length > 0)}>
              <FormattedMessage id="dialog_button_add" defaultMessage={"Add"} />
            </button>}
          </div>
        )
      }
      case MC_CONST.GROUP_MEMBER_VIEW_TYPE.VIEW_MEMBER: {
        return (
          <div className="header">
            <div className="title">
              <FormattedMessage id="dialog_title_group_member" defaultMessage={"Group Members"} />
            </div>
          </div>
        )
      }
      case MC_CONST.GROUP_MEMBER_VIEW_TYPE.CREATE_GROUP: {
        return (
          <div className="header">
            {<button className="back" onClick={this.props.onClose}>
              <FormattedMessage id="dialog_button_cancel" defaultMessage={"Cancel"} />
            </button>}
            <div className="title">
              <FormattedMessage id="dialog_title_create_group" defaultMessage={"Create group"} />
            </div>
            {<button className="done" onClick={this.handleDone} disabled={!(this.state.topicSelected.length > 1)}>
              <FormattedMessage id="dialog_button_add" defaultMessage={"Add"} />
            </button>}
          </div>
        )
      }
      default: {
        break
      }
    }
  }

  renderContent() {
    const { formatMessage } = this.props.intl;
    switch (this.props.view) {
      case MC_CONST.GROUP_MEMBER_VIEW_TYPE.CREATE_GROUP: {
        return (
          <div className="content">
            <div className="group-name">
              <div className="icon"><IconPerson /></div>
              <input
                placeholder={formatMessage(messages.dialog_group_name)}
                onChange={this.handleOnGroupFullNameChange}
                value={this.state.fullName} />
            </div>
            {this.renderSearchView()}
          </div>
        )
      }
      case MC_CONST.GROUP_MEMBER_VIEW_TYPE.VIEW_MEMBER: {
        return (<div className="content">
          <ContactList
            tinode={this.props.tinode}
            contacts={this.state.contacts}
            myUserId={this.props.myUserId}
            // emptyListMessage={no_members}
            // topicSelected={this.state.selectedContact}
            showOnline={false}
            showUnread={false}
            showMode={false}
            onTopicSelected={this.handleMemberSelected}
            showContextMenu={this.props.admin ? this.handleContextMenu : false}
          />
        </div>)
        break
      }
      case MC_CONST.GROUP_MEMBER_VIEW_TYPE.ADD_MEMBER: {
        return (
          <div className="content">
            {this.renderSearchView()}
          </div>
        )
        break
      }
    }
  }

  render() {
    return (
      <Suspense fallback={<div className="panel-form-row"><FormattedMessage id="loading_note"
        defaultMessage="Loading..." description="Message shown when component is loading" /></div>}>
        <div className="dialog-container custom-dialog-container">
          <div className="dialog-background custom-dialog-background" onClick={this.props.onClose}>
          </div>
          <div className="dialog-content">
            <div className="create-group">
              {this.renderHeader()}
              {this.renderContent()}
            </div>
          </div>
        </div>
      </Suspense>
    )
  }
}

export default injectIntl(CreateGroup)